import {s_char} from "../_signals/s_char";
import {CharFieldsUpdate} from "../_api/BEChar";
import {CharacterFieldUpdateField} from "../_payload/CharacterFieldUpdateField";

export default function updChar(fields: CharacterFieldUpdateField[]) {
    let cid = s_char.value.id;
    let supdate = Object.fromEntries(fields.map(obj => [obj.k, obj.v]));
    s_char.value = {...s_char.value, ...supdate};
    console.log("updChar", cid, fields,supdate);
    CharFieldsUpdate(cid, fields);
}